import { useAccount, useMsal } from "@azure/msal-react";
import { AccountInfo, InteractionStatus, IPublicClientApplication } from "@azure/msal-browser";

interface AccountData {
  account: AccountInfo | null | undefined;
  instance: IPublicClientApplication;
  inProgress: InteractionStatus;
}
/*
 * This custom hook is used to write Role based login within the whole Application (Read/Writer)
 * */
export function useMsalAccount(): AccountData {
  const { accounts, instance, inProgress } = useMsal();
  const account = useAccount(accounts[0]);

  return { account, instance, inProgress };
}
